import { renderDateValue, renderOffensesValue } from '../utility/personRelatedRecordDetailHelper';
import { RECORD_CATEGORY_KEYS } from './personRelatedRecordsTabConstants';

export const CATEGORY_LABELS = {
  [RECORD_CATEGORY_KEYS.BOOKINGS]: 'Bookings',
  [RECORD_CATEGORY_KEYS.CAD_INCIDENTS]: 'Cad Incidents',
  [RECORD_CATEGORY_KEYS.CITATIONS]: 'Citations',
  [RECORD_CATEGORY_KEYS.RMS_INCIDENTS]: 'Rms Incidents',
  [RECORD_CATEGORY_KEYS.WARRANTS]: 'Warrants',
};

export const CATEGORY_ROW_ID = {
  [RECORD_CATEGORY_KEYS.BOOKINGS]: 'BookingID',
  [RECORD_CATEGORY_KEYS.CAD_INCIDENTS]: 'ptsEventID',
  [RECORD_CATEGORY_KEYS.CITATIONS]: 'ptsCitationID',
  [RECORD_CATEGORY_KEYS.RMS_INCIDENTS]: 'ptsIncidentID',
  [RECORD_CATEGORY_KEYS.WARRANTS]: 'ptsWarrantID',
};

export const CATEGORY_COLUMNS = {
  [RECORD_CATEGORY_KEYS.CAD_INCIDENTS]: [
    { field: 'EventID', headerName: 'Event ID', width: 150 },
    { field: 'PersonRelationship', headerName: 'Relationship', width: 160 },
    { field: 'CallType', headerName: 'Event Type', width: 160 },
    {
      field: 'ReceivedDate',
      headerName: 'Received Date',
      width: 180,
      valueFormatter: renderDateValue,
    },
    { field: 'Address', headerName: 'Location', width: 220 },
    { field: 'Status', headerName: 'Status', width: 140 },
  ],
  [RECORD_CATEGORY_KEYS.WARRANTS]: [
    { field: 'IssueAgencyID', headerName: 'Agency', width: 150 },
    { field: 'WarrantID', headerName: 'Warrant ID', width: 150 },
    { field: 'IssuedDate', headerName: 'Issued Date', width: 180, valueFormatter: renderDateValue },
    { field: 'StatuteDescription', headerName: 'Offense', width: 220 },
    { field: 'Disposition', headerName: 'Disposition', width: 160 },
    {
      field: 'ServedByDate',
      headerName: 'Served By Date',
      width: 180,
      valueFormatter: renderDateValue,
    },
  ],
  [RECORD_CATEGORY_KEYS.RMS_INCIDENTS]: [
    { field: 'AgencyID', headerName: 'Agency', width: 150 },
    { field: 'IncidentID', headerName: 'Incident ID', width: 160 },
    { field: 'PersonRelationship', headerName: 'Relationship', width: 160 },
    { field: 'CallType', headerName: 'Event Type', width: 160 },
    { field: 'Status', headerName: 'Status', width: 140 },
    {
      field: 'OccurredDate',
      headerName: 'Occurred Date',
      width: 180,
      valueFormatter: renderDateValue,
    },
    { field: 'FullAddressText', headerName: 'Location', width: 220 },
    { field: 'Offenses', headerName: 'Offenses', width: 220, valueFormatter: renderOffensesValue },
  ],
  [RECORD_CATEGORY_KEYS.CITATIONS]: [
    { field: 'AgencyID', headerName: 'Agency', width: 150 },
    { field: 'CitationNumber', headerName: 'Citation Number', width: 170 },
    { field: 'PersonRelationship', headerName: 'Relationship', width: 160 },
    {
      field: 'CitationDate',
      headerName: 'Citation Date',
      width: 180,
      valueFormatter: renderDateValue,
    },
    { field: 'Offenses', headerName: 'Violation', width: 220, valueFormatter: renderOffensesValue },
    { field: 'Court', headerName: 'Court', width: 160 },
    { field: 'CourtDate', headerName: 'Court Date', width: 180, valueFormatter: renderDateValue },
  ],
};
